export default "__VITE_ASSET__Bzlk8dD6__"